module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _vm._v(" "), _c('em', [_vm._v("To Lisa, Caleb, and Maddy.")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("A beautiful woman. A beautiful son. A beautiful friend.")])])]), _c('blockquote', [_c('p', {
    staticClass: "right"
  }, [_vm._v("—HGB")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('em', [_vm._v("To Elaine, Bianca, and Devon, and the four-legged companions who have been part of our family. They mean more to me than they did yesterday and less than they will tomorrow.")])])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('em', [_vm._v("And to the baseball family—those I have competed with and those I have competed against.")])])]), _c('blockquote', [_c('p', {
    staticClass: "right"
  }, [_vm._v("—TLR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1160f805","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 66
// module chunks = 0